











import { defineComponent } from '@vue/composition-api';
import { trackEvent } from './../../../utils/index';
const name = 'ttam-a-link';
export default defineComponent({
  name,
  props: {
    size: {
      type: String,
      default: 'mini',
    },
    target: {
      type: String,
      default: '_blank',
    },
    onClick: {
      type: Function,
      default: () => () => undefined,
    },
    dataTeaClick: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const _onClick = () => {
      emit('click');
      (props as any)?.onClick?.();

      if (props.dataTeaClick) {
        trackEvent(props.dataTeaClick);
      }
    };
    return { name, _onClick };
  },
});
